import dayjs from 'dayjs';

export const getStartAndEndDateFromRange = (
  range: number,
  yearTillDate = false
) => {
  const currentDate = new Date();
  const endDate = new Date(new Date().setDate(currentDate.getDate() - 1)); // yesterday
  let startDate;

  if (yearTillDate) {
    startDate = `${endDate.getFullYear()}-01-01`;
  } else {
    if (range > 1) {
      startDate = new Date(
        new Date(endDate).setDate(endDate.getDate() - range + 1)
      )
        .toISOString()
        .slice(0, 10);
    } else {
      startDate = endDate.toISOString().slice(0, 10);
    }
  }

  return {
    endDate: endDate.toISOString().slice(0, 10),
    startDate,
    noOfDays: range,
  };
};

export const getDaysSinceStartOfYear = (): number => {
  const currentDate = new Date();
  const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
  const differenceInMilliseconds =
    currentDate.getTime() - startOfYear.getTime();
  return Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
};

export const formatFFILabel = (label: string) => {
  const mapping: any = {
    vertical_vibration: 'Vertical vibration',
    rod_torsion: 'Rod torsion',
    longitudinal_load: 'Longitudinal load',
  };
  return mapping[label] || label;
};
